import { PageSection, TextContent, Text, PageSectionVariants, Alert, Divider, EmptyState, Title, EmptyStateBody } from '@patternfly/react-core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchLicenseStatus, StoreState } from '../../store/reducers';

import CurrentLicense from './CurrentLicense';

import './license-page.css';
import { useTranslation } from 'react-i18next';
import UpdateLicense from './UpdateLicense';
import { getCurrentAppClient } from '../../store/selectors';


const LicensePage = () => {

    const appClient = useSelector((state: StoreState) => state.currentAppClient);
    const appConfig = useSelector((state: StoreState) => state.appConfig);
    const currentAppClient = useSelector(getCurrentAppClient);

    // reload license status whenever the page is reloaded, re-opened, or client is changed
    const dispatch = useDispatch();
    const { t } = useTranslation();
    useEffect(() => {
        dispatch(fetchLicenseStatus(appClient));
    }, [dispatch, appClient]);

    const licenseStatus = useSelector((state: StoreState) => state.licenseStatus);
    const licenseStatusError = useSelector((state: StoreState) => state.licenseStatusError);

    return (
        <>
            <PageSection variant={PageSectionVariants.default}>
                <TextContent>
                    <Text component="h1">{t('page.license.title')}</Text>
                </TextContent>
            </PageSection>

            <PageSection variant={PageSectionVariants.light}>

                {appConfig && appConfig.showErrorsInUi && licenseStatusError !== null && (
                    <PageSection>
                        <Alert variant="danger" isInline title="An error occurred when trying to retrieve license information">
                            <p>An error occurred when trying to retrieve license information:</p>
                            <p>{licenseStatusError}</p>
                        </Alert>
                    </PageSection>
                )}

                {!currentAppClient && (
                    <>
                        <EmptyState>
                            <Title headingLevel="h4" size="lg">{t('licensePage.noConfigurationTarget.title')}</Title>
                            <EmptyStateBody>{t('licensePage.noConfigurationTarget.body')}</EmptyStateBody>
                        </EmptyState>
                    </>
                )}

                {currentAppClient && licenseStatusError === null && licenseStatus !== null && licenseStatus.length === 0 && (
                    <>
                        <EmptyState>
                            <Title headingLevel="h4" size="lg">{t('licensePage.noLicense.title')}</Title>
                            <EmptyStateBody>{t('licensePage.noLicense.body')}</EmptyStateBody>
                        </EmptyState>
                    </>
                )}

                {currentAppClient && licenseStatusError === null && licenseStatus !== null && licenseStatus.length > 0 && (
                    <>
                        <PageSection variant={PageSectionVariants.light} className="limit-width">

                            <TextContent className="content-header">
                                <Text component="h2">{t('licensePage.currentLicense', { count: licenseStatus.length })}</Text>
                            </TextContent>
                            {licenseStatus.map((ls, index) => (
                                <div className="license-block" key={ls.id}>
                                    {licenseStatus.length > 1 && (<TextContent className="content-header"><Text component="h3">{t('licensePage.licenseNumber', { number: index + 1 })}</Text></TextContent>)}
                                    <CurrentLicense licenseStatus={ls} />
                                    {index !== licenseStatus.length - 1 && (<Divider className="content-divider" />)}
                                </div>
                            ))}
                        </PageSection>

                        {appConfig && appConfig.allowLicenseUpdate && (<><Divider className="content-divider" /><UpdateLicense /></>)}

                    </>
                )}

            </PageSection>


        </>
    );
}

export default LicensePage;
